module.exports = __webpack_public_path__ + "img/R8801-PX.c1872cc4.jpg";